import { createSlice } from '@reduxjs/toolkit';
import { tr } from '../../i18n/i18n';
import i18n from '../../i18n/i18n';
import { APP_STATUS } from '../../constants';
import { IEventState } from '../../interface/eventModel';
import { createEvent, getEvent, updateEvent, sendReminder } from '../action';

const initialState: IEventState = {
  isLoading: false,
  status: APP_STATUS.IDLE,
  message: '',
  event: null,
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEvent.pending, (state) => {
        state.isLoading = true;
        state.status = APP_STATUS.INITIAL;
      })
      .addCase(createEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.SUCCESS;
        state.message = action.payload.message;
      })
      .addCase(createEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.ERROR;
        state.message = action.payload?.message || i18n.t('toast.failed_to_create_event', 'Failed to create event');
      })
      .addCase(getEvent.pending, (state) => {
        state.isLoading = true;
        state.status = APP_STATUS.INITIAL;
        state.event = null;
      })
      .addCase(getEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.event = action.payload.data;
      })
      .addCase(getEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.ERROR;
        state.message = action.payload?.message || i18n.t('toast.failed_to_fetch_event', 'Failed to fetch event');
        state.event = null;
      })
      .addCase(updateEvent.pending, (state) => {
        state.isLoading = true;
        state.status = APP_STATUS.INITIAL;
      })
      .addCase(updateEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.SUCCESS;
        state.message = action.payload.message;
      })
      .addCase(updateEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.ERROR;
        state.message = action.payload?.message || i18n.t('toast.failed_to_update_event', 'Failed to update event');
      })
      .addCase(sendReminder.pending, (state) => {
        state.isLoading = true;
        state.status = APP_STATUS.INITIAL;
      })
      .addCase(sendReminder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.SUCCESS;
        state.message = action.payload.message;
      })
      .addCase(sendReminder.rejected, (state, action) => {
        state.isLoading = false;
        state.status = APP_STATUS.ERROR;
        state.message = action.payload?.message || i18n.t('toast.failed_to_send_reminders', 'Failed to send reminders');
      });
  },
});

export const { resetState } = eventSlice.actions;

export default eventSlice.reducer;
